import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { ImageUpload } from "@/components/Form/ImageUpload/ImageUpload";

import classes from "../../maintainers.module.scss";

const WebContentMain = ({ data, setData }) => {
	const [files, setFiles] = useState([]);

	useEffect(() => {
		if (typeof data.url_media === "string" || data.url_media instanceof String) {
			let url = data.url_media;
			if (data.url_media === "https://agroinventario-public.s3.us-east-2.amazonaws.com/Agroinventario_corto.mp4") {
				url = "https://agroinventario-public.s3.us-east-2.amazonaws.com/agroinventario.png";
			}
			setFiles([
				{
					preview: url,
					name: "",
				},
			]);
		}
	}, [data.url_media]);

	return (
		<Row className={classes.row_form}>
			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Antetítulo</Form.Label>
					<Form.Control
						value={data && data.pretitle}
						onChange={(e) =>
							setData({
								...data,
								pretitle: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Título</Form.Label>
					<Form.Control
						value={data && data.title}
						onChange={(e) =>
							setData({
								...data,
								title: e.currentTarget.value,
							})
						}
						type="text"
					/>
				</Form.Group>
			</Col>

			<Col md={12} xs={12}>
				<Form.Group className={classes.group_form}>
					<Form.Label className={classes.label}>Foto / Vídeo</Form.Label>
					<ImageUpload data={data} setData={setData} files={files} setFiles={setFiles} />

					<Button
						onClick={() =>
							setData({
								...data,
								url_media: "https://agroinventario-public.s3.us-east-2.amazonaws.com/Agroinventario_corto.mp4",
							})
						}
					>
						Vídeo Agroinventario
					</Button>
				</Form.Group>
			</Col>
		</Row>
	);
};

export default WebContentMain;
